/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSwipeDown = createReactComponent("swipe-down", "IconSwipeDown", [
  ["path", { d: "M12 4a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z", key: "svg-0" }],
  ["path", { d: "M12 12v8", key: "svg-1" }],
  ["path", { d: "M9 17l3 3l3 -3", key: "svg-2" }]
]);

export { IconSwipeDown as default };
//# sourceMappingURL=IconSwipeDown.js.map
